import { render, staticRenderFns } from "./v-card2.vue?vue&type=template&id=5343a553&scoped=true"
import script from "./v-card2.vue?vue&type=script&lang=js"
export * from "./v-card2.vue?vue&type=script&lang=js"
import style0 from "./v-card2.vue?vue&type=style&index=0&id=5343a553&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343a553",
  null
  
)

export default component.exports